import { EAgentLevel } from '../../common';
import { ETxnCategory } from '../data-statistics/dataStatistics';
import { IRefundOrderInfo } from './refundOrder';
import { EDepositStatus } from './splitDetailOrders';

export interface ISplitEntryRecord {
  /** 交易单号 */
  id: string;
  /** 入账账户 */
  depositAccountNo: string;
  /** 入账户名 */
  depositAccountName: string;
  /** 企业名称 */
  companyName: string;
  /** 代理商名称 */
  agentName: string;
  /** 入账总金额 */
  depositAmount: number;
  /** 手续费率 */
  serviceRate: string;
  /** 手续费 */
  serviceAmount?: number;
  /** 实际入账金额 */
  actualDepositAmount: number;
  /** 入账状态 */
  depositStatus: EDepositStatus;
  /** 备注 */
  remark: number;
  /** 入账时间 */
  createTime: string;

}

export interface ISplitEntryRecordParam {
  /** 入账交易单号 */
  id?: string;
  /** 入账总金额(起) */
  minDepositAmount?: string;
  /** 入账总金额(止) */
  maxDepositAmount?: string;
  /** 入账总金额(起) */
  minServiceAmount?: string;
  /** 入账总金额(止) */
  maxServicetAmount?: string;
  /** 入账时间(起) */
  startTime?: string;
  /** 入账时间(止) */
  endTime?: string;
  /** 企业名称 */
  companyId?: string;
  /** 代理商名称 */
  agentId?: string;
  page: number;
  size: number;
}

export interface ISplitEntryRecordItem {
  /** 交易单号 */
  id: string;
  /** 交易完成时间 */
  createTime: string;
  /** 代理商名称	 */
  agentName: string;
  /** 手续费（元）	 */
  serviceAmount: number;
  /** 企业名称	 */
  companyName: string;
  /** 入账状态	 */
  depositStatus: EDepositStatus;
  /** 入账总金额（元） */
  depositAmount: number;
  /** 备注 */
  remark: string;
  /** 收款方账户 */
  depositAccountNo: string;
  /** 手续费率（%） */
  serviceRate: number;

}

export interface IReceiptOrderParams {
  page: number;
  size: number;
  /** 收款订单号 */
  orderNo?: string;
  /** 收款订单号（支付平台） */
  tpOrderNo?: string;
  /** 终端收款编号 */
  pgOrderNo?: string;
  /** 支付通道 LIANLIAN：连连 YEEPAY：易宝支付 */
  channel?: EChannel;
  /** 收款方式 QR_CODE：二维码 PUBLIC_WITHDRAWAL：公域提现  */
  rcptMethod?: ERcptMethod;
  /** 交易方式  WECHAT_PAY：微信支付  ALIPAY：支付宝  WITHDRAWAL_POSTED：提现入账   */
  txnType?: ETxnType;
  /** 交易时间开始 */
  txnTimeStart?: string;
  /** 交易时间结束 */
  txnTimeEnd?: string;
  /** 收款状态  FROZEN：冻结中 UNFREEZING：解冻中 POSTED：已入账 */
  rcptStatus?: ERcptStatus;
  /** 收款企业主键 */
  companyId?: number;
  /** 收款企业 */
  companyName?: string;
  /** 收款企业所属代理商主键 */
  agentId?: number;
  /** 收款企业所属代理商 */
  agentName?: string;
  /** 订单确认状态 */
  confirmed?: EConfirmationStatus;
  /** 是否是门店订单。默认：false */
  fromStore?: boolean;
  /** 最小收款金额 */
  rcptAmtMin?: number;
  /** 最大收款金额 */
  rcptAmtMax?: number;
}

export interface IReceiptOrderInfo {
  /**  */
  id: number;
  /** 收款订单号 */
  orderNo: string;
  /** 收款订单号（支付平台） */
  tpOrderNo: string;
  /** 终端收款编号 */
  pgOrderNo: string;
  /** 支付通道 LIANLIAN：连连 YEEPAY：易宝支付 */
  channel: EChannel;
  /** 收款来源 */
  rcptSource: string;
  /** 收款方式 QR_CODE：二维码 PUBLIC_WITHDRAWAL：公域提现  */
  rcptMethod: ERcptMethod;
  /** 终端所属 */
  terminalBelong: string;
  /** 交易方式  WECHAT_PAY：微信支付  ALIPAY：支付宝  WITHDRAWAL_POSTED：提现入账   */
  txnType: ETxnType;
  /** 收款金额 */
  rcptAmt: number;
  /** 收款手续费 */
  rcptFee: number;
  /** 实际到账金额 */
  actualAmt: number;
  /** 退款金额 */
  refundAmt: number;
  /** 已分金额 */
  distAmt: number;
  /** 待分金额 */
  undistAmt: number;
  /** 分账冻结中金额 */
  frozenAmt: number;
  /** 交易时间 */
  txnTime: string;
  /** 收款状态  FROZEN：冻结中  POSTED：已入账   */
  rcptStatus: ERcptStatus;
  /** 收款企业主键 */
  companyId: number;
  /** 收款企业 */
  companyName: string;
  /** 收款企业所属代理商主键 */
  agentId: number;
  /** 收款企业所属代理商 */
  agentName: string;
  /** 收款企业所属代理商等级 0：特代 1：一代 2：二代  */
  agentLevelType: EAgentLevel;
  /** 是否可退款（为 true 可退）*/
  refundable: boolean;
  /** 退款订单列表 */
  refundOrders?: IRefundOrderInfo[];
  /** 付款人用户唯一标识 */
  payerId: string;
  /** 付款人信息（JSON格式） */
  payerInfo: string;
  /** 确认状态 */
  confirmed: EConfirmationStatus;
}

export interface IUnfreezeReceiptOrderParams {
  /** 收款订单主键 */
  id: number;
  /** 支付密码 */
  payPassword: string;
  /** 验证码 */
  verifyCode: string;
}

export enum EChannel {
  /** 连连 */
  LIANLIAN = 'LIANLIAN',
  /** 易宝支付 */
  YEEPAY = 'YEEPAY',
}

export const channelConfig = {
  [EChannel.LIANLIAN]: '连连',
  [EChannel.YEEPAY]: '易宝支付',
};

export enum ERcptStatus {
  /** 冻结中 */
  FROZEN = 'FROZEN',
  /** 解冻中 */
  UNFREEZING = 'UNFREEZING',
  /** 已入账 */
  POSTED = 'POSTED',
}

export const rcptStatusConfig = {
  [ERcptStatus.FROZEN]: '已冻结',
  [ERcptStatus.UNFREEZING]: '解冻中',
  [ERcptStatus.POSTED]: '正常',
};

export const rcptStatusStyle = {
  [ERcptStatus.FROZEN]: 'danger',
  [ERcptStatus.UNFREEZING]: 'primary',
  [ERcptStatus.POSTED]: 'success',
};

export enum ERcptMethod {
  /** 二维码 */
  QR_CODE = 'QR_CODE',
  /** 公域提现 */
  PUBLIC_WITHDRAWAL = 'PUBLIC_WITHDRAWAL',
  /** 开放API收款 */
  OPENAPI = 'OPENAPI',
  /** POS终端 */
  POS_TERMINAL = 'POS_TERMINAL',
  /** 记账簿收款 */
  ACCOUNT_BOOK = 'ACCOUNT_BOOK',
  /** 易缴费 */
  EASYPAY = 'EASYPAY',
  /** 商户转账（智慧分账） */
  MCH_TRANSFER = 'MCH_TRANSFER'
}

export const rcptMethodConfig = {
  [ERcptMethod.QR_CODE]: '二维码',
  [ERcptMethod.PUBLIC_WITHDRAWAL]: '公域提现',
  [ERcptMethod.OPENAPI]: '开放API收款',
  [ERcptMethod.POS_TERMINAL]: 'POS终端',
  [ERcptMethod.ACCOUNT_BOOK]: '记账簿收款',
  [ERcptMethod.EASYPAY]: '易缴费',
  [ERcptMethod.MCH_TRANSFER]: '商户转账',
};

export enum ETxnType {
  /** 微信支付 */
  WECHAT = 'WECHAT',
  /** 支付宝 */
  ALIPAY = 'ALIPAY',
  /** 提现入账 */
  WITHDRAWAL_POSTED = 'WITHDRAWAL_POSTED',
  /** 银联云闪付 */
  UNIONPAY = 'UNIONPAY',
  /** 刷卡支付 */
  POS = 'POS',
  /** 银行转账 */
  BANK_TRANSFER = 'BANK_TRANSFER',
  /** 分账 */
  DISTRIBUTION = 'DISTRIBUTION',
}

export const txnTypeConfig = {
  [ETxnType.WECHAT]: '微信支付',
  [ETxnType.ALIPAY]: '支付宝',
  [ETxnType.WITHDRAWAL_POSTED]: '提现入账',
  [ETxnType.UNIONPAY]: '银联云闪付',
  [ETxnType.POS]: '刷卡支付',
  [ETxnType.BANK_TRANSFER]: '银行转账',
  [ETxnType.DISTRIBUTION]: '智慧分账',
};

export enum EConfirmationStatus {
  /** 未确认 */
  NO = 'NO',
  /** 已确认 */
  YES = 'YES',
}

export const confirmationStatusConfig = {
  [EConfirmationStatus.NO]: '未确认',
  [EConfirmationStatus.YES]: '已确认',
};

export const confirmationStatusStyle = {
  [EConfirmationStatus.NO]: 'primary',
  [EConfirmationStatus.YES]: 'success',
};

export interface IReceiptOrderTrace {
  /** 交易类别 RECEIPT：收单 REFUND：退款 DISTRIBUTION：分账 */
  txnCategory: ETxnCategory;
  /** 订单ID */
  orderId: number;
  /** 交易订单号 */
  orderNo: string;
  /** 交易金额 */
  txnAmt: number;
  /** 交易手续费 */
  txnFee: number;
  /** 实际到账金额 */
  actualAmt: number;
  /** 交易时间 */
  txnTime: string;
  /** 收款信息 */
  receiptInfo: string;
  /** 付款信息 */
  paymentInfo: string;
  /** 备注 */
  memo: string;
}